import Fetcher from "../fetcher";
import { isResponse, constant } from "./support/utils";
import { isPlainObject } from "../../support/helpers";
import Store from "../context";
import { getValueAtPath } from "../utils";
import { getLocaleFromCurrency } from "../context/common/locale";
import SearchParams from "../init/searchparams";

const NULL_FUNCTION = constant(null);

const DEFAULT_POST_INIT = {
  method: 'POST',
  headers: { 
    'Content-Type': 'application/json'
  }
};
const DEFAULT_RETRY_CONDITIONS = [
  RetryOnBadResponse,
  Fetcher.RetryOnNetworkError,
  Fetcher.RetryOnTimeout
];

const DEFAULT_TIMEOUT = 5000; // 5s

function isJsonResponse(response) {
  if (isResponse(response)) {
    try {
      const contentType = response.headers.get('content-type');
      return /\bapplication\/json\b/i.test(contentType);
    } catch (e) {}
  }

  return false;
}

function getJsonResponseBody(response) {
  return isJsonResponse(response)
    ? response.json()
    : response.text().then(JSON.parse).catch(NULL_FUNCTION);
}

function RetryOnBadResponse(response) {
  return isResponse(response) && !(isJsonResponse(response) && response.ok);
}

// To update the headers object dynamically, add the key/value pair in the headers object
function withSharedHeaders($fetcher) {
  const descriptors = Object.getOwnPropertyDescriptors($fetcher);
  const $refetcher = (resource, options) => {
    const initOptions = isPlainObject(options) ? options : {};
    const selectedLocale = getValueAtPath(Store.getState(), 'locale') || getLocaleFromCurrency(SearchParams.get('currency'));

    return $fetcher(resource, {
      ...initOptions,
      headers: {
        'x-flw-lang': selectedLocale.toUpperCase()
      }
    })
  };

  return Object.defineProperties($refetcher, descriptors);
}

export {
  DEFAULT_POST_INIT,
  DEFAULT_RETRY_CONDITIONS,
  DEFAULT_TIMEOUT,
  getJsonResponseBody,
  isJsonResponse,
  RetryOnBadResponse,
  withSharedHeaders
}
